import React from 'react';

import './spinner.scss';

interface IKnovioPreviewSpinnerProps {
    classname?: string;
}

const KnovioPreviewSpinner = ({ classname }: IKnovioPreviewSpinnerProps) => {
    return <span className={`${classname || ''} knovio-preview-spinner`}/>;
};

export default KnovioPreviewSpinner;
